// axiosConfig.js
import axios from "axios";

const instance = axios.create({
  baseURL: "https://48ab-2406-7400-35-3afe-a9f0-2188-38f3-9aed.ngrok-free.app", 
});

export default instance;

